export default "__VITE_ASSET__cee982ca__"